import { createContext, useContext, ReactNode } from "react";
import { IntegrationTypeCategory } from "../hooks/useIntegrationTypes";

interface RoutingContextType {
  handleAddIntegration: (category?: IntegrationTypeCategory) => void;
  handleEditIntegration: (
    integrationId: string,
    integrationType?: string,
  ) => void;
  isStandaloneMode: boolean;
}

const RoutingContext = createContext<RoutingContextType | undefined>(undefined);

interface RoutingProviderProps {
  children: ReactNode;
  handleAddIntegration: (category?: IntegrationTypeCategory) => void;
  handleEditIntegration: (
    integrationId: string,
    integrationType?: string,
  ) => void;
  isStandaloneMode: boolean;
}

export function RoutingProvider({
  children,
  handleAddIntegration,
  handleEditIntegration,
  isStandaloneMode,
}: RoutingProviderProps) {
  return (
    <RoutingContext.Provider
      value={{ handleAddIntegration, handleEditIntegration, isStandaloneMode }}
    >
      {children}
    </RoutingContext.Provider>
  );
}

export function useRouting() {
  const context = useContext(RoutingContext);
  if (context === undefined) {
    throw new Error("useRouting must be used within a RoutingProvider");
  }
  return context;
}
